  <xpo-card>
    <xpo-card-header>
      <xpo-card-title class="mile-calc-title">Calculated Miles</xpo-card-title>
    </xpo-card-header>
    <xpo-card-content>
      <h1 class="result">The distance between {{ originZip }} and {{ destinationZip }} is: {{ miles }} miles.</h1>
    </xpo-card-content>
  </xpo-card>
